// extracted by mini-css-extract-plugin
module.exports = {"markdown":"markdown-module--markdown--a5wsj","mTop2":"markdown-module--mTop2--E2usK"};